import React from "react";
import { useRouteError } from "react-router-dom";
import ErrorPage from "../../pages/error";

function ErrorBoundary() {
  let error = useRouteError();
  console.error(error);
  return <ErrorPage message="Lo lamentamos, parece que ha surgido un problema en la página que estás buscando." />;
}

export default ErrorBoundary;
